function resetTabIndex(childNodes) {
  if (!childNodes.length) {
    return;
  }

  const IGNORE_NODES = ['#comment', '#text'];

  childNodes.forEach((el) => {
    if (!IGNORE_NODES.includes(el.nodeName)) {
      el.setAttribute('tabIndex', -1);
      el.classList.add('off-default-focus');
      resetTabIndex(el.childNodes);
    }
  });
}

export function enterListener(el) {
  return (e) => {
    if (e.key === 'Enter') {
      if (el.firstChild && el.firstChild.nodeName !== '#text') {
        el.firstChild.click();
      } else {
        el.click();
      }
    }
  };
}

export function setTabAttributes(el, className, modifiers) {
  el.classList.add(className || 'default-focus');
  el.classList.add('off-default-focus');

  if (modifiers.element) {
    el.firstChild.setAttribute('tabIndex', -1);
    el.firstChild.classList.add('off-default-focus');
  } else {
    resetTabIndex(el.childNodes);
  }
}
